export default "__VITE_ASSET__Bbb9oel2__"